import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
/**
 * 分页 mixin
 */

/**
 * @type {Vue.VueConstructor}
 */
var mixin = {
  data: function data() {
    return {
      pageSize: 25,
      total: 0,
      currentPage: 1,
      // 传递给 table.loading 的参数，pageSize 改变时会设置此值
      pageLoading: false,
      sortKey: ""
    };
  },
  created: function created() {
    var _this = this;
    var myrefresh = function myrefresh() {
      if (typeof _this.refresh === "function") {
        _this.refresh();
      } else {
        console.error("你使用了 mixin page.js，却没有实现 refresh 方法。");
      }
    };
    this.$watch("pageSize", function () {
      if (_this.currentPage !== 1) {
        _this.currentPage = 1;
      } else {
        myrefresh();
      }
    });
    this.$watch("currentPage", myrefresh);
    if (typeof this.searchText !== "undefined") {
      var timer = null;
      this.$watch("searchText", function () {
        clearTimeout(timer);
        timer = setTimeout(this.refresh, 200);
      });
    }
  },
  methods: {
    setLoading: function setLoading(value) {
      this.pageLoading = value;
    },
    /**
     * 此方法用于从后端返回的数据中抽取分页数据，并设置到当前 vm
     * 每个功能后端返回的分页数据结构应当是一致的
     * @param {Object} data 
     */
    setPageVars: function setPageVars(data) {
      // 海海的接口这样返回
      if (data.per_page) {
        this.page = data.page * 1;
        this.total = data.count * 1;
        this.pageSize = data.per_page * 1;
      } else if (data.page_size) {
        // 虎子的接口这样返回
        this.page = data.page;
        this.total = data.num_records;
        this.pageSize = data.page_size;
      } else {
        throw new Error("不能识别的分页信息");
      }
    },
    onCurrentPageChange: function onCurrentPageChange(page) {
      this.currentPage = page;
    },
    onSortChange: function onSortChange(_ref) {
      var column = _ref.column,
        key = _ref.key,
        order = _ref.order;
      key = column.sortKey || key;
      var sortKey = order === "asc" ? key : "-".concat(key);
      if (sortKey === this.sortKey) {
        return;
      }
      this.sortKey = sortKey;
      this.refresh();
    },
    onRowClick: function onRowClick(row, key) {
      var _this2 = this;
      var grids = Object.keys(this.$refs).filter(function (ref) {
        return /^grid/.test(ref);
      }).map(function (ref) {
        return _this2.$refs[ref];
      });
      if (grids.length === 0) {
        return;
      }
      var finalGrid = null;
      if (grids.length > 1) {
        finalGrid = grids.filter(function (grid) {
          return grid.data.indexOf(row) > -1;
        })[0];
      } else {
        finalGrid = grids[0];
      }
      finalGrid.selectAll(false);
      finalGrid.toggleSelect(key);
    }
  }
};
export default mixin;